import { Edit, SimpleForm, TextInput, DateInput, NumberInput, BooleanInput } from 'react-admin';

export const Tbl_giornataEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <NumberInput source="id" disabled />
            <NumberInput source="legaStagioneId" />
            <NumberInput source="legaId" disabled />
            <NumberInput source="stagioneId" disabled />
            <NumberInput source="numero" />
            <TextInput source="nome" />
            <DateInput source="dataInizio" />
            <DateInput source="dataFine" />
            <TextInput source="note" multiline />
            <BooleanInput source="flDisputata" />
            <BooleanInput source="flVisibile" />
            <BooleanInput source="flAttivo" />
            <BooleanInput source="flAnnullato" />
            <NumberInput source="ordinamento" />
            <DateInput source="createdAt" disabled />
            <DateInput source="updatedAt" disabled />
        </SimpleForm>
    </Edit>
);
